
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React, { useState } from "react";
import Link from "next/link";
import useTranslation from "next-translate/useTranslation";
import { setUserData } from "../../ducks/signIn";
import { signInFB } from "../../services/facebook";
import NarrowPage from "../../components/NarrowPage";
import AppleButton from "../../components/AppleButton";
import Alert from "../../components/Alert";
import FacebookButton from "../../components/FacebookButton";
import Head from "next/head";
import Script from "next/script";
import { generateId } from "../../util/generateId";
import styles from "./styles/SignIn.module.css";
import { setLoadingBar } from "../../ducks/siteData";
import { api } from "../../services/api";
import { useRouter } from "next/router";
import { signInAppleWeb } from "../../services/apple";
import FBScript from "@/src/components/FBScript";
export default function SignIn() {
    // const [rememberMe, setRememberMe] = useState(false);
    const [username, setUsername] = useState(null);
    const [password, setPassword] = useState(null);
    const [error, setError] = useState(null);
    const { t } = useTranslation("common");
    const { t: registerT } = useTranslation("auth");
    const router = useRouter();
    function sendSignIn() {
        setLoadingBar(true);
        const { premium } = router.query;
        // setTimeout(() => {
        api
            .post("/auth/signin/" + router.locale, {
            username,
            password,
            // rememberMe,
            premium,
        })
            .then((response) => {
            if (response.status >= 400) {
                throw response.status;
            }
            if (response.data.premiumUpgrade) {
                router.push("/membership-done");
            }
            else {
                router.push("/lobby");
            }
            setUserData(response.data);
        })
            .catch(() => {
            if (error) {
                setError(null);
                setTimeout(() => {
                    setError(true);
                }, 300);
            }
            else {
                setError(true);
            }
        })
            .then(() => {
            setLoadingBar(false);
        });
        // }, 1000);
    }
    function handleKeyDown(e) {
        if (e.key === "Enter") {
            sendSignIn();
        }
    }
    return (<NarrowPage title={t("Log in")}>
      <FBScript />
      <Script onLoad={() => {
            window.AppleID.auth.init({
                clientId: "com.chesshotel.service",
                scope: "",
                redirectURI: "https://www.chesshotel.com/api/v1/auth/apple/redirect",
                state: "Eksätravägen975031",
                nonce: generateId(),
                usePopup: true, // or false defaults to false
            });
        }} src="https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js"/>

      <Head>
        <title>{"Chess Hotel | " + t("Log in")}</title>
        <meta name="description" content={t("description")}/>
        <meta name="keywords" content={t("keywords")}/>
      </Head>
      <div className={styles.body}>
        <FacebookButton onClick={() => signInFB()} text="Log in with Facebook"/>
        <div className={styles.appleBtn}>
          <AppleButton onClick={() => signInAppleWeb()} text="Log in with Apple"/>
        </div>
        <div className={styles.line}>
          <span>{t("or")}</span>
        </div>
        {/* <form className="flex flex-col"> */}
        {error && <Alert>{registerT("Wrong username or password")}</Alert>}
        <label htmlFor="username" className={styles.label}>
          {registerT("Username")}
        </label>
        <input id="username" autoFocus type="text" onChange={(event) => setUsername(event.target.value)}/>

        <label htmlFor="password" className={styles.label}>
          {t("Password")}
        </label>
        <input id="password" type="password" onChange={(event) => setPassword(event.target.value)} onKeyDown={handleKeyDown}/>

        <div className="flex justify-end mt-2 space-x-4 text-sm">
          <Link className="hover:text-orange-400" href={"/signIn/passwordRecovery"}>
            {registerT("Lost your password?")}
          </Link>
        </div>
        <div className="flex flex-col items-center w-full">
          <div className="mt-6">
            <button id="signInBtn" className={styles.signInButton} onClick={() => sendSignIn()}>
              {t("Log in")}
            </button>
          </div>
          <div className="mt-4 text-sm underline">
            <Link className="hover:text-orange-400" href={"/register"}>
              {t("Sign up")}
            </Link>
          </div>
        </div>

        {/* </form> */}
      </div>
    </NarrowPage>);
}

    async function __Next_Translate__getStaticProps__196976e9856__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/signIn/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__196976e9856__ as getStaticProps }
  